import { useMutation } from '@apollo/client';
import { CREATE_CATEGORY } from '../graphql';
import { CreateCategory } from '../graphql-types/CreateCategory';
import { CreateCategoryVariables } from '../graphql-types/CreateCategory';

export const useCreateCategory = () => {
  const [mutate, state] = useMutation<
    CreateCategory,
    CreateCategoryVariables
  >(CREATE_CATEGORY, {
    refetchQueries: ['GetCategories'],
  });

  const createCategory = async (input: { name: string }) => {
    const { data } = await mutate({
      variables: { input },
    });

    if (!data?.createCategory.success) {
      throw new Error(data?.createCategory.message || 'Create failed');
    }
    
    return data?.createCategory;
  };

  return {
    createCategory,
    ...state,
  };
};
